// Detekterer mobil-enhet. Mer permissiv: aksepterer alt av
// (a) mobil UA + touch, (b) smal viewport + touch. Desktop-nettleser med
// bred vindusstørrelse eller uten touch regnes IKKE som mobil.
export function isMobileDevice() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isPhoneUA = /iPhone|iPod|Android|iPad|Mobile/i.test(ua);
  const isIPadOS = /Macintosh/i.test(ua) && typeof document !== "undefined" && "ontouchend" in document;
  const hasTouch =
    (navigator.maxTouchPoints || 0) > 0 ||
    (typeof window !== "undefined" && "ontouchstart" in window);
  const narrowViewport = typeof window !== "undefined" && window.innerWidth <= 900;
  // Godta enten UA-treff, iPadOS-heuristikk, eller smal touch-viewport
  if ((isPhoneUA || isIPadOS) && hasTouch) return true;
  if (narrowViewport && hasTouch) return true;
  return false;
}

export function isStandalonePWA() {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(display-mode: standalone)").matches ||
         window.navigator.standalone === true;
}
